import { render } from "./FormTag.vue?vue&type=template&id=07402559&ts=true"
import script from "./FormTag.vue?vue&type=script&lang=ts"
export * from "./FormTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__